import { FundFamilyUseAllocationTableColumnEditorSelectDef } from "gen/model/fundFamilyUseAllocationTableColumnEditorSelectDef";
import { FundFamilyUseAllocationTableColumnEditorTextDef } from "gen/model/fundFamilyUseAllocationTableColumnEditorTextDef";
import React, { useRef } from "react";
import { FundFamilyUseAllocationTableColumnCellRendererProps } from "shared/components/fund-family-use-allocation/FundFamilyUseAllocationTableProps";
import { isFundFamilyUseAllocationTableRowEditable } from "shared/components/fund-family-use-allocation/FundFamilyUseAllocationTableUtils";
import { SelectOption } from "shared/components/input/select/SelectOption";
import { SimpleSelect } from "shared/components/input/select/SimpleSelect";
import { SimpleTextInput } from "shared/components/input/text/SimpleTextInput";
import { getMaybernTableCellError } from "shared/components/table/maybern/MaybernTableErrors";
import { MaybernTableFocusCellRendererWrapper } from "shared/components/table/maybern/MaybernTableFocusCellRendererWrapper";

export const FundFamilyUseAllocationTableEditorSelect: React.FC<
  FundFamilyUseAllocationTableColumnCellRendererProps
> = ({ columnDef, ...params }) => {
  const editor =
    columnDef.editor as FundFamilyUseAllocationTableColumnEditorSelectDef;
  const ref = useRef<never>(null);
  return (
    <MaybernTableFocusCellRendererWrapper params={params} inputRef={ref}>
      <SimpleSelect
        ref={ref}
        title={editor.placeholder || undefined}
        value={params.value}
        onChangeValue={params.setValue}
        variant="simple-table"
        isDisabled={!isFundFamilyUseAllocationTableRowEditable(params.node)}
        error={getMaybernTableCellError(params)}
      >
        {editor.options?.map(({ label, value }) => (
          <SelectOption value={value} key={value}>
            {label}
          </SelectOption>
        ))}
      </SimpleSelect>
    </MaybernTableFocusCellRendererWrapper>
  );
};

export const FundFamilyUseAllocationTableEditorText: React.FC<
  FundFamilyUseAllocationTableColumnCellRendererProps
> = ({ columnDef, ...params }) => {
  const editor =
    columnDef.editor as FundFamilyUseAllocationTableColumnEditorTextDef;
  const ref = useRef<never>(null);
  return (
    <MaybernTableFocusCellRendererWrapper params={params} inputRef={ref}>
      <SimpleTextInput
        ref={ref}
        variant="simple-table"
        placeholder={editor.placeholder || undefined}
        value={params.value}
        onChange={params.setValue}
        isDisabled={!isFundFamilyUseAllocationTableRowEditable(params.node)}
        error={getMaybernTableCellError(params)}
      />
    </MaybernTableFocusCellRendererWrapper>
  );
};
